/** Full date, year + month, or year only — the three formats the backend accepts. */
const DOB_PATTERN = /^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?$/;

export const DOB_FORMAT_MESSAGE = "Use the format YYYY-MM-DD, YYYY-MM or YYYY";

/** Shared between Single Screening and Monitoring entry creation — same field, same rule. */
export function validateDob(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed === "") return null;
  const m = DOB_PATTERN.exec(trimmed);
  if (!m) return DOB_FORMAT_MESSAGE;
  // Partial dates are checked as their first day, so the current year/month is
  // never "in the future".
  const iso = `${m[1]}-${m[2] ?? "01"}-${m[3] ?? "01"}`;
  const d = new Date(`${iso}T00:00:00Z`);
  // Round-trip guard rejects impossible dates (e.g. 2020-02-31, 2020-13).
  if (Number.isNaN(d.getTime()) || d.toISOString().slice(0, 10) !== iso) {
    return "Enter a valid date";
  }
  if (d > new Date()) return "Date of birth can't be in the future";
  return null;
}
